import React, {useMemo} from 'react';
import ReactTooltip from 'react-tooltip';
import clsx from 'clsx';
import {groupBy} from "lodash";
import {DownloadIcon} from "presentation/common/components/style-guide/pdf-viewer/thumbnail-item/download";
import {downloadFile} from "presentation/common";

import styles from './styles.module.scss';

export const DocumentsList = props => {
  const {className = '', documents = [], onDelete} = props;
  const groupByType = useMemo(() => groupBy(documents, doc => doc.type), [documents]);

  return (
    <>
      <ReactTooltip
        backgroundColor="white"
        border
        borderColor="var(--primary)"
        effect="solid"
        id="downloadItemTooltip"
        textColor="var(--primary)"
        type="info">
        Descargar
      </ReactTooltip>

      <div className={clsx('px-4 pb-4 grid grid-cols-1 gap-2', className)}>
        {Object.keys(groupByType).map(type => (
          <div className={styles.group} key={type}>
            <p className="pt-2">{groupByType[type]?.[0]?.name}</p>
            {groupByType[type].map((item) => (
              <div className={styles.groupRow} key={item.id}>
                <span>{item.createAt}</span>

                <div className="flex gap-3 items-center">
                  <DownloadIcon
                    className="outline-none cursor-pointer"
                    data-for="downloadItemTooltip"
                    data-tip
                    size={14}
                    onClick={() => downloadFile(item.downloadUrl, item.fileName)}
                  />
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};
